export interface IStreamlinedSerologyOrder {
    donorShieldDirectId?: number,
    organType?: number,
    reason?: number,
    scheduledDonationDate?: string,
    bloodDrawDate?: string,
    alias: string,
    recpAlias: string,
    name: string,
    dob: string,
    serologyTests: string,
    shipToAttn: string,
    shipToAddress1: string,
    shipToAddress2: string,
    shipToCity: string,
    shipToState: string,
    shipToZip: string,
    shipToPhone: string,
    shipToEmail: string,
    isPhlebot: boolean
}